// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div {
  border: 1px solid var(--ods-color-gray-30);
  border-radius: 4px;
  min-width: 10rem;
  position: relative;
  background-color: var(--ods-color-white);
}
div.p-width p {
  padding-left: 8px;
}
div .paragragh {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0.5rem;
  color: var(--ods-color-gray-100);
  font-size: 0.875rem;
  cursor: pointer;
  height: 32px;
}
div .paragragh p {
  margin: 0;
}
div ul {
  list-style-type: none;
  position: absolute;
  background-color: var(--ods-color-white);
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 100%;
  max-height: 300px;
  overflow-y: auto;
  top: calc(100% + 2px);
  left: 0;
  border: 1px solid var(--ods-color-gray-30);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 0;
  margin: 0;
}
div ul li {
  padding: 0.5rem;
}
div ul li:hover {
  background-color: var(--ods-color-gray-5);
}
div ul li ods-checkbox {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/planselect-dropdown-checkbox/planselect-dropdown-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;AACF;AAEI;EACE,iBAAA;AAAN;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AADJ;AAGI;EACE,SAAA;AADN;AAKE;EACE,qBAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,OAAA;EACA,0CAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;AAHJ;AAKI;EACE,eAAA;AAHN;AAKM;EACE,yCAAA;AAHR;AAMM;EACE,WAAA;AAJR","sourcesContent":["div {\n  border: 1px solid var(--ods-color-gray-30);\n  border-radius: 4px;\n  min-width: 10rem;\n  position: relative;\n  background-color: var(--ods-color-white);\n\n  &.p-width {\n    p {\n      padding-left: 8px;\n    }\n  }\n  .paragragh {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.4rem 0.5rem;\n    color: var(--ods-color-gray-100);\n    font-size: 0.875rem;\n    cursor: pointer;\n    height: 32px;\n\n    p {\n      margin: 0;\n    }\n  }\n\n  ul {\n    list-style-type: none;\n    position: absolute;\n    background-color: var(--ods-color-white);\n    font-size: 0.875rem;\n    cursor: pointer;\n    min-width: 100%;\n    max-height: 300px;\n    overflow-y: auto;\n    top: calc(100% + 2px);\n    left: 0;\n    border: 1px solid var(--ods-color-gray-30);\n    border-radius: 4px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    padding: 0;\n    margin: 0;\n\n    li {\n      padding: 0.5rem;\n\n      &:hover {\n        background-color: var(--ods-color-gray-5);\n      }\n\n      ods-checkbox {\n        width: 100%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
